export default __webpack_public_path__ + "static/media/nflStaff13.10d7cbc7.jpg";